<template>
  <div v-show="showIcons" class="hstack align-items-center gap-1 mx-4">
    <button
      class="btn btn-danger"
      type="button"
      :aria-label=" isDeleting
        ? $t('backend.candidacy.components.management_controls.restore')
        : $t('backend.candidacy.components.management_controls.delete')"
      @click.prevent="toggleDelete"
    >
      <AVIcon :icon="isDeleting ? 'rotate-left' : 'trash'" />
    </button>

    <button
      class="btn btn-dark"
      type="button"
      :aria-label="$t('backend.candidacy.components.management_controls.insert_new')"
      @click.prevent="$emit('toggle-new-options')"
    >
      <AVIcon icon="plus" />
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Collapse } from "@assemblyvoting/electa-ui";

export default defineComponent({
  name: "ManagementControls",
  emits: ["toggle-delete", "toggle-new-options", "toggle-accordion"],
  props: {
    showIcons: {
      type: Boolean,
      default: true,
    },
    target: {
      type: String,
      required: true,
    },
    isItemOpen: {
      type: Boolean,
      default: false,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleDelete() {
      if (this.isItemOpen) {
        const createdItem = document.querySelector(`#${this.target}`);
        Collapse.getOrCreateInstance(createdItem).hide();
        this.$emit("toggle-accordion");
      }
      this.$emit("toggle-delete");
    },
  },
});
</script>
